import { colorize } from "../utils/string/colorize";
export class SimpleLogger {
    _mode; // TODO: Remove Mode - see https://github.com/lun-energy/web-main/pull/337#discussion_r1298195840
    _sourceId;
    constructor(mode, sourceId) {
        this._mode = mode;
        this._sourceId = sourceId;
    }
    log(...args) {
        this._doLog("info", ...args);
    }
    warn(...args) {
        this._doLog("warn", ...args);
    }
    error(...args) {
        this._doLog("error", ...args);
    }
    info(...args) {
        this._doLog("info", ...args);
    }
    _doLog(level, ...args) {
        const log = console[level];
        // If we're in the browser, we want to log to the console to utilize the browser's
        // console features.
        if (typeof window !== "undefined") {
            log(...args);
            return;
        }
        const logInfo = this._getLogInfo({ level }, args);
        if (this._mode === "production") {
            log(JSON.stringify(logInfo));
            return;
        }
        log(logInfo.sourceId ? `[${logInfo.sourceId}]` : "", logInfo.message ? logInfo.message + " - " : "", colorize(level, JSON.stringify(logInfo)));
    }
    _getLogInfo(properties, args) {
        let message;
        if (args.length === 1) {
            const item = args[0];
            if (item instanceof Error) {
                message = item.message;
            }
            else if (typeof item === "string") {
                message = item;
            }
            else {
                try {
                    message = JSON.stringify(item); // Convert to a JSON string
                }
                catch {
                    message = String(item);
                }
            }
        }
        else {
            try {
                message = JSON.stringify(args); // Convert the whole array to a JSON string
            }
            catch {
                message = String(args);
            }
        }
        return { message, ...properties, sourceId: this._sourceId };
    }
}
//# sourceMappingURL=SimpleLogger.js.map